import React, { Component } from "react";
import PropTypes from "prop-types";

import "./style.css";

class Stepper extends Component {
  static propTypes = {
    currentStep: PropTypes.number,
    setCurrentStep: PropTypes.func,
    steps: PropTypes.array,
    readOnly: PropTypes.bool
  };

  constructor(props) {
    super(props);
    this.state = {
      currentTabIndex: 0
    };
  }

  renderStep(item) {
    const { currentStep, setCurrentStep, steps, readOnly } = this.props;

    let classNameStep = "step";
    let lineNextStep = <div></div>;
    let onClickStep = setCurrentStep.bind(this, item.number);

    if (item.number === currentStep) {
      classNameStep = "step current";
    } else if (currentStep > item.number) {
      classNameStep = "step finished";
      lineNextStep = <div className="current"></div>;
    } else {
      onClickStep = null;
    }

    if (readOnly){
      onClickStep = null;
    }

    return (
      <React.Fragment key={"step_" + item.number}>
        <div className={classNameStep} id={item.number} onClick={onClickStep}>
          <span>{item.number}</span>
          <span>{item.title}</span>
        </div>
        {item.number < steps.length ? lineNextStep : null}
      </React.Fragment>
    );
  }

  render() {
    return <div className="progress">{this.props.steps && this.props.steps.map((item, key) => this.renderStep(item))}</div>;
  }
}
export default Stepper;
